<template>
  <div class="TcAppointmentForm fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <TcAppointmentFormStart v-if="state=='start'"></TcAppointmentFormStart>
      <TcAppointmentFormSending v-if="state=='sending'"></TcAppointmentFormSending>
      <TcAppointmentFormSuccess v-if="state=='success'"></TcAppointmentFormSuccess>
      <TcAppointmentFormError v-if="state=='error'"></TcAppointmentFormError>
    </div>
  </div>
</template>

<script>
import TcAppointmentFormStart from './TcAppointmentFormStart.vue';
import TcAppointmentFormSending from './TcAppointmentFormSending.vue';
import TcAppointmentFormSuccess from './TcAppointmentFormSuccess.vue';
import TcAppointmentFormError from './TcAppointmentFormError.vue';

export default {
  name: 'TcAppointmentForm',
  components: {
    TcAppointmentFormStart,
    TcAppointmentFormSending,
    TcAppointmentFormSuccess,
    TcAppointmentFormError,
  },
  props: ['delegation','time_slot'],
  data () {
    return {
      type: 'phone_call',
      reason: '',
      phone: '',
      form_ok: false,
      error_msg: '',
      state: 'start', // posibles estados: start, sending, success, error
    }
  },
  mounted () {
    this.phone = this.$root.user_profile.mobile1 || this.$root.user_profile.phone1;
    // MODO DESARROLLO CAMBIO DE ESTADO DIRECTAMENTE
    // Poner creatingAppointment: true, en TcCalendar
    /*
    console.log('MODO DESARROLLO ESTADO DE NUEVA CITA');
    this.$props.time_slot = {
      date: new Date(),
      time: '12:35',
    }
    this.setState('error');
    */
    // /MODO DESARROLLO
  },
  computed: {
    isFormOk: function() {
      if(this.type=='phone_call') {
        return this.reason!='' && this.phone!='';
      } else {
        return this.reason!='';
      }
    }
  },
  methods: {
    setState: function(new_state) {
      this.state = new_state;
    },
    getDateTimeFormat: function() {
      let date=this.$props.time_slot.date.toFlatDateStr();
      let time=this.$props.time_slot.time.replace(':','') + '00';
      return date+time;
    },
    createAppointment: function() {
      this.setState('sending');
      //console.log('CLICK');
      fetch('/post.php',{
        method: 'POST',
        body: JSON.stringify({
          action: 'create_appointment',
          access_token: this.$root.access_token,
          params: {
            access_token: this.$root.access_token,
            room_id: this.$parent.selected_room.id,
            reserved_at: this.getDateTimeFormat(),
            phone: this.phone,
            type: this.type,
            reason: this.reason,
          }
        })
      }).then(response => response.json()).then( json => {
        if(json.response && json.response===true) {
          this.setState('success');
          this.error_msg = '';
        } else {
          this.setState('error');
          this.error_msg = json.mensaje;
        }
        //console.log('createAppointment JSON', json);
      })
    }
  }

}
</script>